import { render, staticRenderFns } from "./documentAddComponent.vue?vue&type=template&id=c9fdca2a&"
import script from "./documentAddComponent.vue?vue&type=script&lang=js&"
export * from "./documentAddComponent.vue?vue&type=script&lang=js&"
import style0 from "./documentAddComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports